/**
 * Wann gilt das Mobile-Layout? (docs/MOBILE.md, Regel L1)
 *
 * - Hochformat: unter 768 px Breite.
 * - Handy quer: Touch-Gerät mit höchstens 500 px Höhe — auch wenn die Breite über 768 px liegt.
 *   Sonst bekäme ein quer gehaltenes Handy Sidebar und Desktop-Header und kaum Platz für Inhalt.
 *
 * Einzige Quelle für TS-Code (Media-Queries in Template-CSS und `matchMedia`). Die `.css`-Dateien
 * können keine TS-Konstanten lesen und tragen dieselben Zeichenketten wörtlich — bei Änderungen
 * dort mitziehen (Suche nach `max-height: 500px`).
 *
 * Bewusst nur Komma-Listen, kein `not (…)` innerhalb der Abfrage: das versteht Safari erst ab 16.4.
 */

/** Mobile-Layout: schmal ODER Handy quer. */
export const MOBILE_LAYOUT_QUERY =
  '(max-width: 767px), (max-height: 500px) and (pointer: coarse)';

/** Gegenstück: ab 768 px Breite, aber nicht Handy quer. */
export const DESKTOP_LAYOUT_QUERY =
  '(min-width: 768px) and (min-height: 501px), (min-width: 768px) and (pointer: fine), (min-width: 768px) and (pointer: none)';

export function isMobileLayout(): boolean {
  return window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
}
